/**
 * Where the paid plan opens first (core waitlist.ts; docs/WAITLIST.md): the pilot, as data next to the state packs. Owner, 2026-10-05:
 * the pilot is Salt Lake County, Utah. OPEN_COUNTIES (env) replaces this list and an admin's "Open <county>" adds to it; copy never
 * names a county itself, it reads the first open one.
 */
export const PILOT_COUNTIES = ["UT:Salt Lake"] as const;
